define("shared/errors/instagram-auth", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.UnknownLoginError = _exports.InsufficientPermissionsError = _exports.FetchPageError = _exports.ExtensionBlockedError = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  class InsufficientPermissionsError extends Error {
    constructor(message) {
      super(message);
      this.name = 'InsufficientPermissionsError';
    }
  }
  _exports.InsufficientPermissionsError = InsufficientPermissionsError;
  class UnknownLoginError extends Error {
    constructor(message) {
      super(message);
      this.name = 'UnknownLoginError';
    }
  }
  _exports.UnknownLoginError = UnknownLoginError;
  class FetchPageError extends Error {
    constructor() {
      super();
      this.name = 'FetchPageError';
    }
  }
  _exports.FetchPageError = FetchPageError;
  class ExtensionBlockedError extends Error {
    constructor() {
      super();
      this.name = 'ExtensionBlockedError';
    }
  }
  _exports.ExtensionBlockedError = ExtensionBlockedError;
});